import './Media.scss';
import { MediaData } from '../../models/app-data-model';
import React from 'react';
import { getContentHubDamAsset } from '../../utils/get-contenthub-dam-asset';

export type MediaProps = {
  mediaData: MediaData;
};

const Media: React.FC<MediaProps> = ({ mediaData }) => {
  const addClass = mediaData?.add_a_class?.join(' ');
  const contenthubDamAsset = getContentHubDamAsset(mediaData.contenthub_asset, mediaData.manual_overwrites);

  return(    
      <img title={contenthubDamAsset?.title} src={contenthubDamAsset?.url} alt={contenthubDamAsset?.alt_text} className={addClass} loading='lazy'/>    
  );
};

export default Media;